import produce from 'immer';
import { Reducer } from 'redux';

import { TasksState, TasksTypes } from '../types';

const initialState: TasksState = {
    isLoading: false,
    tasks: [],
};

const tasksReducer: Reducer<TasksState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case TasksTypes.GET_LIST_TASKS: {
                draft.isLoading = false;
                draft.tasks = action.payload.tasks;
                break;
            }
            case TasksTypes.REQUEST_GET_LIST_TASKS: {
                draft.isLoading = true;
                break;
            }
            case TasksTypes.SAVE_TASKS: {
                draft.isLoading = false;
                draft.tasks = action.payload.tasks;
                break;
            }
            case TasksTypes.REQUEST_SAVE_TASKS: {
                draft.isLoading = true;
                break;
            }
            case TasksTypes.DELETE_TASK: {
                draft.isLoading = false;
                draft.tasks = draft.tasks.filter((x) => x.id !== action.payload.id);
                break;
            }
            case TasksTypes.REQUEST_DELETE_TASK: {
                draft.isLoading = true;
                break;
            }
            case TasksTypes.DELETE_TASKS: {
                draft.isLoading = false;
                draft.tasks = action.payload.ids
                    ? draft.tasks.filter((x) => !action.payload.ids.includes(x.id))
                    : draft.tasks;
                break;
            }
            case TasksTypes.REQUEST_DELETE_TASKS: {
                draft.isLoading = true;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { tasksReducer };
